@let optionsValue = options();
@let messageValue = message();

@if (optionsValue.closeButton) {
  <button (click)="remove()" aria-label="close" class="toast-close-button">
    <span aria-hidden="true">×</span>
  </button>
}
@if (title()) {
  <div [class]="optionsValue.titleClass" class="toast-title" [attr.aria-label]="title()">
    {{ title() }} @if (duplicatesCount) {[{{ duplicatesCount + 1 }}]}
  </div>
}
<ng-container *ngTemplateOutlet="template(); context: {$implicit: actions}"></ng-container>
@if (messageValue && optionsValue.enableHtml) {
  <div [class]="optionsValue.messageClass"
       [innerHTML]="messageValue">
  </div>
}
@if (messageValue && !optionsValue.enableHtml) {
  <div [class]="optionsValue.messageClass"
       [attr.aria-label]="messageValue">
    {{ messageValue }}
  </div>
}
@if (optionsValue.progressBar) {
  <div>
    <div class="toast-progress" [style.width]="width() + '%'"></div>
  </div>
}
